import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";
import TravelAttachmentsTable, {
    TravelAttachmentTableProps
} from "../../../pages/consumers/travel/components/TravelAttachmentsTable";


interface OwnProps extends SlideOverProps, TravelAttachmentTableProps {}

type Props = OwnProps;

// @ts-ignore
const TravelAttachmentsTableModal = NiceModal.create<Props>(({onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <TravelAttachmentsTable {...rest}/>
        </SlideOver>
    )
})

export default TravelAttachmentsTableModal;
